/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreparedGeneralRowDto
 */
export interface PreparedGeneralRowDto {
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    currency: PreparedGeneralRowDtoCurrencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGeneralRowDto
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGeneralRowDto
     */
    sellDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGeneralRowDto
     */
    paymentDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    exchangeRate?: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    type: PreparedGeneralRowDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    projectNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    teamsNames?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    correctedInvoiceNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PreparedGeneralRowDto
     */
    correctedInvoiceIssueDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreparedGeneralRowDto
     */
    tv: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    vat: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedGeneralRowDto
     */
    validationError?: string | null;
}


/**
 * @export
 */
export const PreparedGeneralRowDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type PreparedGeneralRowDtoCurrencyEnum = typeof PreparedGeneralRowDtoCurrencyEnum[keyof typeof PreparedGeneralRowDtoCurrencyEnum];

/**
 * @export
 */
export const PreparedGeneralRowDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type PreparedGeneralRowDtoTypeEnum = typeof PreparedGeneralRowDtoTypeEnum[keyof typeof PreparedGeneralRowDtoTypeEnum];


/**
 * Check if a given object implements the PreparedGeneralRowDto interface.
 */
export function instanceOfPreparedGeneralRowDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "sellDate" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "tv" in value;
    isInstance = isInstance && "vat" in value;

    return isInstance;
}

export function PreparedGeneralRowDtoFromJSON(json: any): PreparedGeneralRowDto {
    return PreparedGeneralRowDtoFromJSONTyped(json, false);
}

export function PreparedGeneralRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreparedGeneralRowDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceNumber': json['invoiceNumber'],
        'currency': json['currency'],
        'issueDate': (new Date(json['issueDate'])),
        'sellDate': (new Date(json['sellDate'])),
        'paymentDate': (new Date(json['paymentDate'])),
        'amount': json['amount'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'type': json['type'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'teamsNames': !exists(json, 'teamsNames') ? undefined : json['teamsNames'],
        'correctedInvoiceNumber': !exists(json, 'correctedInvoiceNumber') ? undefined : json['correctedInvoiceNumber'],
        'correctedInvoiceIssueDate': !exists(json, 'correctedInvoiceIssueDate') ? undefined : (json['correctedInvoiceIssueDate'] === null ? null : new Date(json['correctedInvoiceIssueDate'])),
        'tv': json['tv'],
        'vat': json['vat'],
        'validationError': !exists(json, 'validationError') ? undefined : json['validationError'],
    };
}

export function PreparedGeneralRowDtoToJSON(value?: PreparedGeneralRowDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceNumber': value.invoiceNumber,
        'currency': value.currency,
        'issueDate': (value.issueDate.toISOString()),
        'sellDate': (value.sellDate.toISOString()),
        'paymentDate': (value.paymentDate.toISOString()),
        'amount': value.amount,
        'exchangeRate': value.exchangeRate,
        'type': value.type,
        'comment': value.comment,
        'projectNumber': value.projectNumber,
        'teamsNames': value.teamsNames,
        'correctedInvoiceNumber': value.correctedInvoiceNumber,
        'correctedInvoiceIssueDate': value.correctedInvoiceIssueDate === undefined ? undefined : (value.correctedInvoiceIssueDate === null ? null : value.correctedInvoiceIssueDate.toISOString()),
        'tv': value.tv,
        'vat': value.vat,
        'validationError': value.validationError,
    };
}

